'use client';

import { QueryBoundary } from '@/components/ui/QueryBoundary';
import { Flex, Skeleton } from '@skin-seoul/design-system';
import { BMSMCampaignBanner } from '@skin-seoul/shared-components';
const BMSMCampaignBannerSection = () => {
  return <Flex width="100%" px="16px" data-sentry-element="Flex" data-sentry-component="BMSMCampaignBannerSection" data-sentry-source-file="BMSMCampaignBannerSection.tsx">
      <Flex pt={{
      base: '20px',
      tablet: '16px'
    }} borderTop="1px solid" borderColor="neutral.75" width="100%" data-sentry-element="Flex" data-sentry-source-file="BMSMCampaignBannerSection.tsx">
        <QueryBoundary clientOnly loadingFallback={<Skeleton height="130px" width="100%" backgroundColor="neutral.50" />} data-sentry-element="QueryBoundary" data-sentry-source-file="BMSMCampaignBannerSection.tsx">
          <BMSMCampaignBanner data-sentry-element="BMSMCampaignBanner" data-sentry-source-file="BMSMCampaignBannerSection.tsx" />
        </QueryBoundary>
      </Flex>
    </Flex>;
};
export default BMSMCampaignBannerSection;